<template>
  <div>
    <WorkExperience />
  </div>
</template>

<script>
import WorkExperience from '../components/WorkExperience.vue'

export default {
  name: 'Work',
  components: {
    WorkExperience,
  },
}
</script>
